import { FormattedMessage } from 'react-intl'
import { Text, H2 } from 'app/common/typography'
import { SPACING } from 'app-v2/design-tokens'
import { colors } from 'shared/assets/styles'
import styled from 'styled-components'
import tomatoImg from 'shared/assets/images/bk-tomato-food.png'
import { Button, Spacer } from 'app-v2/design-systems'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

export const NoComplaintScreen = () => {
    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(push({ pathname: '/' }))
    }

    return (
        <StyledErrorBanner>
            <StyledImage src={tomatoImg} alt={'tomato'} />
            <StyledTextContainer>
                <H2 color={colors.bbqBrown}>
                    <FormattedMessage id="complaint.oups" />
                </H2>
                <Text color={colors.bbqBrown}>
                    <FormattedMessage id="complaint.getError" />
                </Text>
            </StyledTextContainer>
            <Spacer size={SPACING.S} />
            <Button
                buttonColor={colors.fieryRed}
                labelColor={colors.mayoEggWhite}
                onClick={handleClick}>
                <FormattedMessage id="complaint.button" />
            </Button>
            <Spacer size={SPACING.S} />
        </StyledErrorBanner>
    )
}

const StyledErrorBanner = styled.div`
    min-height: 60vh;
    margin-top: 90px;
    text-align: center;
    padding: 0 ${SPACING.M};
`

const StyledImage = styled.img`
    height: 240px;
    aspect-ratio: 1;
`

const StyledTextContainer = styled.div`
    display: flex;
    gap: ${SPACING.S};
    flex-direction: column;
`
